export const USER_GROUP = [
   {
      groupCode: 1,
      description: 'IT Group',
      manager: 'Hong Kien',
      selected: false,
      primaryGroup: false,
   },
   {
      groupCode: 2,
      description: 'Design Group',
      manager: 'Hong Kien',
      selected: false,
      primaryGroup: false,
   },
];
